import React from 'react';
import { DOCUMENT_OPTIONS, RfiCreateStep } from '../../utils';
import RfiDocumentField from '../RfiDocumentField';
import { useField } from 'react-final-form';
import AddCustomRfiDocument from '../AddCustomRfiDocument';
import { useTranslation } from 'react-i18next';

const DOCS_FIELD_NAME = 'documents';
const CUSTOM_DOCS_FIELD_NAME = 'customDocuments';

const StepDocuments: React.FC<RfiCreateStep> = (props) => {
  const { input: customDocumentsInput } = useField(CUSTOM_DOCS_FIELD_NAME);

  const { t } = useTranslation();

  return (
    <>
      <input hidden name={DOCS_FIELD_NAME} />
      <input hidden name={CUSTOM_DOCS_FIELD_NAME} />

      {DOCUMENT_OPTIONS.map(({ value, label }, index) => (
        <RfiDocumentField
          key={value}
          type={value}
          label={t(label)}
          name={`${DOCS_FIELD_NAME}[${index}]`}
        />
      ))}

      {customDocumentsInput?.value?.map((d: any, index: number) => (
        <RfiDocumentField
          key={d.name}
          type="other"
          label={d.name}
          name={`${CUSTOM_DOCS_FIELD_NAME}[${index}]`}
        />
      ))}

      <AddCustomRfiDocument name={CUSTOM_DOCS_FIELD_NAME} />
    </>
  );
};

export default StepDocuments;
